import { Button } from '@peacecover/component';
import { usePhotoCardMarketPopupStore } from '../store/usePhotoCardMarketPopupStore';
import { Trans } from 'react-i18next';
import { t } from 'i18next';

const BeforeReviewPopup = () => {
  const { setIsBeforeReviewPopupOpen } = usePhotoCardMarketPopupStore();

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 dark:bg-black/55 z-10">
      <div
        className={
          'flex flex-col gap-[40px] bg-background-elevated rounded-[24px] px-[14px] pt-[32px] pb-[16px] mb-[10px] w-[311px] h-[200px] fixed bottom-[36px] left-1/2 transform -translate-x-1/2 z-20'
        }
      >
        <div className="flex flex-col gap-[8px] leading-tight items-center">
          <p className="h-[20px] text-text-main-lv1 font-bold text-[17px] text-center">
            {t('NewTradingPhotoCardMarket.beforeReviewPopupTitle')}
          </p>
          <p className="h-[36px] text-text-main-lv4 text-[15px] text-center">
            <Trans
              i18nKey="NewTradingPhotoCardMarket.beforeReviewPopupDescription"
              components={{ br: <br /> }}
            />
          </p>
        </div>
        <div className="flex flex-col gap-[8px] leading-none">
          <Button
            btnColor="primary"
            size="large"
            onClick={() => setIsBeforeReviewPopupOpen(false)}
            className="text-[17px] font-semibold"
          >
            {t('confirm')}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default BeforeReviewPopup;
